import React, { useState } from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleListWithPriceAndCostPrintRequest,
  FabricStylePriceAndCostInquiryCriteriaBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupFabricStyleModule } from "../modules/ModuleUtil.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import { ConfigManager } from "../config/ConfigManager.js";
import CustomTable from "../gui_components/CustomTable.js";
class FabricStylePriceCost extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "FabricStyle list With Price & Cost Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new FabricStylePriceAndCostInquiryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowPurchaseOrderModule: false,
      isShowPurchaseReceiptModule: false,
      moduleForPopup: [],
      warehouses: [],
      isShowColorLookup: false,
      colorLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isDisableFields: false,
      isCollapsible_open: true,
      productTypes: [],
      productTypePageListForAutoCompleteList: new Array(),
      showAutoCompleteProductTypeList: true,
      patternTypes: [],
      patternTypePageListForAutoCompleteList: new Array(),
      showAutoCompletePatternTypeList: true,
      patternTypeCategories: [],
      patternTypeCategoryPageListForAutoCompleteList: new Array(),
      showAutoCompletePatternTypeCategoryList: true,
      makeTypes: [],
      makeTypePageListForAutoCompleteList: new Array(),
      showAutoCompleteMakeTypeList: [],
      isShowFabricStyleModule: false,
      is3PL: false,
    };
    this.fabricCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let productTypes = attribute_cache.productTypes;
    if (productTypes != null || productTypes != undefined) {
      productTypes.map((attr) => {
        this.state.productTypes.push(attr);
      });
    }
    let patternTypes = attribute_cache.patternTypes;
    if (patternTypes != null || patternTypes != undefined) {
      patternTypes.map((attr) => {
        this.state.patternTypes.push(attr);
      });
    }
    let patternTypeCategories = attribute_cache.patternTypeCategories;
    if (patternTypeCategories != null || patternTypeCategories != undefined) {
      patternTypeCategories.map((attr) => {
        this.state.patternTypeCategories.push(attr);
      });
    }

    let makeTypes = attribute_cache.makeTypes;
    if (makeTypes != null || makeTypes != undefined) {
      makeTypes.map((attr) => {
        this.state.makeTypes.push(attr);
      });
    }
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      "FabricStyle"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    let productTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.productTypes,
      "Product Type"
    );
    this.setState({ productTypeLookupHandler: productTypeLookupHandler });
    let patternTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.patternTypes,
      "Pattern Type"
    );
    this.setState({ patternTypeLookupHandler: patternTypeLookupHandler });

    let patternTypeCategoryLookupHandler = new GenericAttributeLookupHandler(
      this.state.patternTypeCategories,
      "Type Category"
    );
    this.setState({
      patternTypeCategoryLookupHandler: patternTypeCategoryLookupHandler,
    });

    let makeTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.makeTypes,
      "Product Type"
    );
    this.setState({ makeTypeLookupHandler: makeTypeLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadFabricStylePriceInquiryList(criteria);
  };
  loadFabricStylePriceInquiryList = (listRequest) => {
    // if (SecurityAccessManager.FabricStylePriceListPriceCostInquiry_IsAccessible()) {
    ReportService.inquireFabricStyleListWithPriceAndCostInquiryDetails(
      listRequest,
      this.loadFabricStylePricePageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadFabricStylePricePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.costPriceMaintenanceBean != null
    ) {
      let invoiceInfoDataList = [];
      if (
        !isEmptyArray(response.data.costPriceMaintenanceBean.costPriceLines)
      ) {
        invoiceInfoDataList =
          response.data.costPriceMaintenanceBean.costPriceLines;
        this.setState({
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: invoiceInfoDataList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        isCollapsible_open: false,
      });

      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateFabricPriceCostReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleListWithPriceAndCostPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 2) {
      // if (
      //   SecurityAccessManager.FabricStylePriceListPriceCostInquiry_IsAccessible()
      // ) {
      ReportService.generateFabricStyleListWithPriceAndCostPrintReport(
        listRequest,
        this.generateFabricStyleListWithPriceAndCostPrintReport,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(3);
      // }
    }
  };
  generateFabricStyleListWithPriceAndCostPrintReport = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new FabricStylePriceAndCostInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new Array(),
      colorList: [],
      isDisableFields: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new FabricStylePriceAndCostInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowResetButton: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new Array(),
      colorList: [],
      isDisableFields: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  generateExcel = () => {
    this.generateFabricPriceCostReport(2);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = true;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        fabricPageListForAutoCompleteList: suggestion,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readandsetFabricStyleDetail(e.target.value);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };

  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };
  onProductTypeCodeChange = (e) => {
    let productTypeCode = e.target.value;
    this.state.showAutoCompleteProductTypeList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteProductTypeList;
    if (isEmpty(productTypeCode)) {
      this.state.showAutoCompleteProductTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteProductTypeList;
      let criteria = this.state.criteria;
      criteria.productTypeCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteProductTypeList: showAutoCompleteList,
        criteria: criteria,
        productTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && productTypeCode !== "") {
      this.readProductTypeBySearchString(productTypeCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readProductType = (productType) => {
    let productTypeBean = null;
    let productTypeData = null;
    this.state.productTypes.map((ln) => {
      if (ln.code === productType) {
        productTypeBean = ln;
        productTypeData = new BaseBean();
        productTypeData.code = ln.code;
        productTypeData.description = ln.description;
      }
    });
    if (!isEmpty(productTypeBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.productTypeCode = productTypeBean.code;
      this.state.showAutoCompleteProductTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteProductTypeList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteProductTypeList: showAutoCompleteList,
      });
    }
  };
  readProductTypeBySearchString = (searchString) => {
    let productTypeData = this.state.productTypes;
    let simpleAutoCompleteList = new Array();
    if (productTypeData.length > 0 && productTypeData != null) {
      productTypeData.map((sp) => {
        let productTypeBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(productTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      productTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  productTypeEnterKeyEventHandler = (e) => {
    let productTypeCode = e.target.value;
    this.readProductType(productTypeCode);
    this.setState({
      productTypePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteProductTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteProductTypeList: showAutoCompleteList });
  };
  patternTypeCodeOnChange = (e) => {
    let patternTypeCode = e.target.value;
    this.state.showAutoCompletePatternTypeList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
    if (isEmpty(patternTypeCode)) {
      this.setState({
        showAutoCompletePatternTypeList: false,
      });
      let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
      let criteria = this.state.criteria;
      criteria.patternTypeCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePatternTypeList: showAutoCompleteList,
        criteria: criteria,
        patternTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "patternTypeCode" &&
      showAutoCompleteList === true &&
      patternTypeCode !== ""
    ) {
      this.readPatternTypeBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
    this.readPatternType(patternTypeCode);
  };
  readPatternType = (patternTypeCode) => {
    let patternTypeBean = null;
    let patternTypeData = null;
    this.state.patternTypes.map((ln) => {
      if (ln.code === patternTypeCode) {
        patternTypeBean = ln;

        patternTypeData = new BaseBean();
        patternTypeData.code = ln.code;
        patternTypeData.description = ln.description;
      }
    });
    if (!isEmpty(patternTypeBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.patternTypeCode = patternTypeBean.code;
      this.state.showAutoCompletePatternTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompletePatternTypeList: showAutoCompleteList,
      });
    }
  };
  readPatternTypeBySearchString = (searchString) => {
    let patternTypeData = this.state.patternTypes;
    let simpleAutoCompleteList = new Array();
    if (patternTypeData.length > 0 && patternTypeData != null) {
      patternTypeData.map((sp) => {
        let patternTypeBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(patternTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      patternTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  patternTypeEnterKeyEventHandler = (e) => {
    let patternType = e.target.value;
    this.readPatternType(patternType);
    this.setState({
      patternTypePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletePatternTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePatternTypeList: showAutoCompleteList });
  };

  patternTypeCategoryCodeOnChange = (e) => {
    let patternTypeCategoryCode = e.target.value;
    this.state.showAutoCompletePatternTypeCategoryList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList =
      this.state.showAutoCompletePatternTypeCategoryList;
    if (isEmpty(patternTypeCategoryCode)) {
      this.setState({
        showAutoCompletePatternTypeList: false,
      });
      let showAutoCompleteList =
        this.state.showAutoCompletePatternTypeCategoryList;
      let criteria = this.state.criteria;
      criteria.patternTypeCategoryCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePatternTypeCategoryList: showAutoCompleteList,
        criteria: criteria,
        patternTypeCategoryPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "patternTypeCategoryCode" &&
      showAutoCompleteList === true &&
      patternTypeCategoryCode !== ""
    ) {
      this.readPatternTypeCategoryBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readPatternTypeCategory = (patternTypeCategory) => {
    let patternTypeCategoryBean = null;
    let patternTypeCategoryData = null;
    this.state.patternTypeCategories.map((ln) => {
      if (ln.code === patternTypeCategory) {
        patternTypeCategoryBean = ln;
        patternTypeCategoryData = new BaseBean();
        patternTypeCategoryData.code = ln.code;
        patternTypeCategoryData.description = ln.description;
      }
    });
    if (!isEmpty(patternTypeCategoryBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.patternTypeCategoryCode = patternTypeCategoryBean.code;
      this.state.showAutoCompletePatternTypeCategoryList = false;
      let showAutoCompleteList =
        this.state.showAutoCompletePatternTypeCategoryList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompletePatternTypeCategoryList: showAutoCompleteList,
      });
    }
  };
  readPatternTypeCategoryBySearchString = (searchString) => {
    let patternTypeCategoryData = this.state.patternTypeCategories;
    let simpleAutoCompleteList = new Array();
    if (patternTypeCategoryData.length > 0 && patternTypeCategoryData != null) {
      patternTypeCategoryData.map((sp) => {
        let patternTypeCategoryBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(patternTypeCategoryBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      patternTypeCategoryPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  patternTypeCategoryEnterKeyEventHandler = (e) => {
    let patternTypeCategory = e.target.value;
    this.readPatternTypeCategory(patternTypeCategory);
    this.setState({
      patternTypeCategoryPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletePatternTypeCategoryList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompletePatternTypeCategoryList: showAutoCompleteList,
    });
  };
  onMakeTypeCodeChange = (e) => {
    let makeTypeCode = e.target.value;
    this.state.showAutoCompleteMakeTypeList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
    if (isEmpty(makeTypeCode)) {
      this.state.showAutoCompleteMakeTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
      let criteria = this.state.criteria;
      criteria.makeTypeCode = "";

      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        makeTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && makeTypeCode !== "") {
      this.readMakeTypeBySearchString(makeTypeCode);
    }
    if (e.target.name == "makeTypeCode") {
      temp_fabricStyledata["makeTypeCode"] = e.target.value;
      let productType_List = this.state.makeTypes;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_fabricStyledata["makeTypeCode"] = pdtType.code;
          temp_fabricStyledata["makeTypeName"] = pdtType.description;
          this.state.showAutoCompleteMakeTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readMakeTypeBySearchString(searchString) {
    let makeTypeData = this.state.makeTypes;
    let simpleAutoCompleteList = new Array();
    if (makeTypeData.length > 0 && makeTypeData != null) {
      makeTypeData.map((makeTypeDatas) => {
        let simpleItemBean = {
          code: makeTypeDatas.code,
          description: makeTypeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletetypeLists) =>
        simpleAutoCompletetypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ makeTypePageListForAutoCompleteList: filteredSuggestions });
  }
  makeTypeEnterKeyEvent = (e) => {
    let temp_data = this.state.criteria;
    let makeTypeCode = e.target.value;
    temp_data["makeTypeCode"] = e.target.value;
    let productType_List = this.state.makeTypes;
    let makeTypeCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        makeTypeCodeBean = pdtType;
      }
    });
    if (!isEmpty(makeTypeCodeBean)) {
      let temp_data = this.state.criteria;
      temp_data.makeTypeCode = makeTypeCodeBean.code;
      this.setState({
        criteria: temp_data,
        makeTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteMakeTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteMakeTypeList: showAutoCompleteList });
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      moduleForPopup: [],
    });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item Name" : "FabricStyle Name", "fabricStyleName", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Style", "productTypeCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Type", "patternTypeCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Content", "makeTypeCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Categories", "patternTypeCategoryCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={
            this.state.is3PL ? "Item list With Price & Cost Inquiry" : "FabricStyle list With Price & Cost Inquiry"
          }
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          fabricLookupHandler={this.state.fabricLookupHandler}
          customerLookupHandler={this.state.customerLookupHandler}
          warehouseLookupHandler={this.state.warehouseLookupHandler}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricCodeRef={this.fabricCodeRef}
          customerCodeRef={this.customerCodeRef}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          onProductTypeCodeChange={this.onProductTypeCodeChange}
          productTypeEnterKeyEventHandler={this.productTypeEnterKeyEventHandler}
          displayAutoCompleteProductTypeList={
            this.displayAutoCompleteProductTypeList
          }
          patternTypeCodeOnChange={this.patternTypeCodeOnChange}
          patternTypeEnterKeyEventHandler={this.patternTypeEnterKeyEventHandler}
          displayAutoCompletePatternTypeList={
            this.displayAutoCompletePatternTypeList
          }
          patternTypeCategoryCodeOnChange={this.patternTypeCategoryCodeOnChange}
          patternTypeCategoryEnterKeyEventHandler={
            this.patternTypeCategoryEnterKeyEventHandler
          }
          displayAutoCompletePatternTypeCategoryList={
            this.displayAutoCompletePatternTypeCategoryList
          }
          onMakeTypeCodeChange={this.onMakeTypeCodeChange}
          makeTypeEnterKeyEvent={this.makeTypeEnterKeyEvent}
          displayAutoCompleteMakeTypeList={this.displayAutoCompleteMakeTypeList}
          showHideSecondHeader={this.showHideSecondHeader}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  let productTypeLookupHandler = props.productTypeLookupHandler;
  let isDisableFields = props.isDisableFields;
  const fabricCodeRef = props.fabricCodeRef;
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const onProductTypeCodeChange = (e) => {
    props.onProductTypeCodeChange(e);
  };
  const productTypeEnterKeyEventHandler = (e) => {
    props.productTypeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteProductTypeList = () => {
    props.displayAutoCompleteProductTypeList();
  };
  const patternTypeCodeOnChange = (e) => {
    props.patternTypeCodeOnChange(e);
  };
  const patternTypeEnterKeyEventHandler = (e) => {
    props.patternTypeEnterKeyEventHandler(e);
  };
  const displayAutoCompletePatternTypeList = () => {
    props.displayAutoCompletePatternTypeList();
  };

  const patternTypeCategoryCodeOnChange = (e) => {
    props.patternTypeCategoryCodeOnChange(e);
  };
  const patternTypeCategoryEnterKeyEventHandler = (e) => {
    props.patternTypeCategoryEnterKeyEventHandler(e);
  };
  const displayAutoCompletePatternTypeCategoryList = (e) => {
    props.displayAutoCompletePatternTypeCategoryList(e);
  };

  const onMakeTypeCodeChange = (e) => {
    props.onMakeTypeCodeChange(e);
  };
  const makeTypeEnterKeyEvent = (e) => {
    props.makeTypeEnterKeyEvent(e);
  };
  const displayAutoCompleteMakeTypeList = (e) => {
    props.displayAutoCompleteMakeTypeList(e);
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={true}
            lookupHandler={fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onFabricColourCodeChange}
            name="colorCode"
            placeholder="color"
            value={criteria.colorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Category</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="patternTypeCategoryCode"
            onChange={patternTypeCategoryCodeOnChange}
            value={criteria.patternTypeCategoryCode}
            lookupRequired={true}
            lookupHandler={props.patternTypeCategoryLookupHandler}
            enterKeyEventHandler={patternTypeCategoryEnterKeyEventHandler}
            autoCompleteListData={
              props.patternTypeCategoryPageListForAutoCompleteList
            }
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompletePatternTypeCategoryList}
            showAutoCompleteList={props.showAutoCompletePatternTypeCategoryList}
            disabled={isDisableFields}
          />
        </Col>
        <Col>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => props.showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Style</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onProductTypeCodeChange}
              name="productTypeCode"
              placeholder="productTypeCode"
              value={criteria.productTypeCode}
              lookupRequired={true}
              lookupHandler={props.productTypeLookupHandler}
              enterKeyEventHandler={productTypeEnterKeyEventHandler}
              autoCompleteListData={
                props.productTypePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteProductTypeList}
              showAutoCompleteList={props.showAutoCompleteProductTypeList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Type</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="patternTypeCode"
              onChange={patternTypeCodeOnChange}
              value={criteria.patternTypeCode}
              lookupRequired={true}
              lookupHandler={props.patternTypeLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={patternTypeEnterKeyEventHandler}
              autoCompleteListData={
                props.patternTypePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompletePatternTypeList}
              showAutoCompleteList={props.showAutoCompletePatternTypeList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Content</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onMakeTypeCodeChange}
              name="makeTypeCode"
              value={criteria.makeTypeCode}
              lookupRequired={true}
              lookupHandler={props.makeTypeLookupHandler}
              enterKeyEventHandler={makeTypeEnterKeyEvent}
              autoCompleteListData={props.makeTypePageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteMakeTypeList}
              showAutoCompleteList={props.showAutoCompleteMakeTypeList}
              disabled={isDisableFields}
            ></InputTextbox>
          </Col>
        </Row>
      )}
    </div>
  );
}
function FabricStylePriceListPriceCostInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <FabricStylePriceCost {...props} name="" /> <br />
    </div>
  );
}
export default FabricStylePriceListPriceCostInquiry;
